import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LanguageService } from '@core/services/language/language.service';

/**
 * Notificaciones GDP: ninguna mutación debe fallar en silencio.
 * error() extrae el detail del ProblemDetail RFC-7807 del back si existe.
 */
@Injectable({ providedIn: 'root' })
export class GdpNotifyService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly language = inject(LanguageService);

  success(messageKey: string, suffix?: string): void {
    const message = this.language.translate(messageKey) + (suffix ? ` ${suffix}` : '');
    this.snackBar.open(message, undefined, { duration: 2500 });
  }

  error(err?: unknown): void {
    const detail = (err as { error?: { detail?: string } })?.error?.detail;
    this.snackBar.open(
      detail ?? this.language.translate('common.error'),
      undefined,
      { duration: 4500, panelClass: 'gdp-snackbar-error' }
    );
  }

  /** Error con un mensaje i18n propio (no viene del back). */
  errorMessage(messageKey: string): void {
    this.snackBar.open(
      this.language.translate(messageKey),
      undefined,
      { duration: 4500, panelClass: 'gdp-snackbar-error' }
    );
  }
}
